// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-child[data-v-7e8de158]{cursor:pointer;margin-top:10px;padding:5px 0;margin-left:45px;display:flex;align-items:flex-start;white-space:normal;color:#6b768b}.nav-child[data-v-7e8de158]:hover{text-decoration:underline;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none;text-decoration-skip:none;-webkit-text-decoration-skip:none}.selected[data-v-7e8de158]{font-weight:600;color:#0f2345}.counter[data-v-7e8de158]{margin-left:4px}", ""]);
// Exports
module.exports = exports;
